import { AfterViewInit } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { QResult } from '../../../../models';
import { TacheMode, TacheStageCursusInfo } from '../../../../models/formation/formation.model';
import { CoreService, HttpService } from '../../../../services';
import { StageService } from '../services/stage-modal.service';



@Component({
  selector: 'queoval-stage-tache',
  templateUrl: './tache.component.html',
  styleUrls: ['./tache.component.css']
})
/*
* Composant pour l'affichage des taches
*/
export class TacheComponent implements OnInit, AfterViewInit {

  // #region CONSTRUCTEUR
  constructor(
    public service: StageService,
    private http: HttpService,
    private core: CoreService
  ) {}
  // #endregion

  // #region VARIABLES GLOBALES

  /** permet de lancer la fonction subscribe dans le composant TacheTableauComponent */
  public Init$: Subject<void> = new Subject<void>();
  /** model qui stock les infos du cursus et la liste des idents en mode CURSUS */
  public InfosStageCursus: TacheStageCursusInfo;
  /** boolean connecté au bouton cursus  */
  public IsModeCursus: boolean;
  /** Enum qui stock le mode a envoyer au composant parent */
  public tacheMode: TacheMode;

  // #endregion

  // #region CYCLE DE VIE

  public ngOnInit(): void {
    this.tacheMode = TacheMode.MANU;
    this.InfosStageCursus = new TacheStageCursusInfo();
    this.IsModeCursus = false;
  }
  public ngAfterViewInit(): void {
    setTimeout(() => { this.Init$.next(); }, 250);
  }

  // #endregion

  // #region FONCTIONS PUBLIQUES

  /**
   * change le mode envoyer au composant, par défault le mode = "MANU"
   * @param selectedMode mode : MANU | AUTO | CURSUS
   */
  public changeMode(selectedMode: string) {
    switch (selectedMode) {
      case "MANU":
        this.IsModeCursus = false;
        this.tacheMode = TacheMode.MANU;
        break;
      case "AUTO":
        this.IsModeCursus = false;
        this.tacheMode = TacheMode.AUTO;
        break;
      case "PARAM":
        this.IsModeCursus = false;
        this.tacheMode = TacheMode.PARAM;
        break;
      case "CURSUS":
        if (this.IsModeCursus) {
          this.getListInfosCursus(this.service.Stage.Ident);
        }
        this.tacheMode = this.IsModeCursus ? TacheMode.CURSUS : TacheMode.MANU;
        break;
      default:
        this.IsModeCursus = false;
        this.tacheMode = TacheMode.MANU;
        break;
    }
    //utilisé pour lancer le subsribe dans le composant enfant aprés qu'il est était init
    setTimeout(() => { this.Init$.next(); }, 250);
      
    
  }

  /**
   * verifie si la liste de taches du composant enfant est vide grace à un @Output
   * @param isEmpty $event recu du composant enfant
   * @param stage   infos du stage en cours 
   */
  public verifyEmptyList(isEmpty: boolean, stage: TacheStageCursusInfo) {
    stage.LstTacheIsEmpty = isEmpty;
  }

  // #endregion

  // #region FONCTIONS PRIVES

  /**
   * permet de retourner les infos du cursus lié au stage,
   * retourne aussi une liste d'infos pour chaque stage lié à ce cursus
   * @param idStage id du stage
   */
  private getListInfosCursus(idStage: string) {
    this.http.getHttp<QResult<TacheStageCursusInfo>>(`${this.core.AppParams.apiUrl}api/Stage/Taches/INIT_LIST_CURSUS_IDENT/${idStage}`)
      .subscribe((result: QResult<TacheStageCursusInfo>) => {
        if (!result.HasError) {
          this.InfosStageCursus = result.Value;
        }
      });
  }
  // #endregion
}
